import * as React from 'react';

import {TrackingContext} from '@homeaway/react-event-tracking';
import {Dropdown, DropdownItem} from '@homeaway/react-dropdown';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_DOWN__16} from '@homeaway/svg-defs';
import travelerSvgMap from '../../utils/traveler-svgs';

const travelerRE = /service=(\w+\%3A\%2F\%2F[\.\w]+).*/;

export class Traveler extends React.Component {
    static contextType = TrackingContext;

    edapTrigger = (item) => {
        const field = {
            actionlocation: `header.${item.text.replace(/\s/g, '').toLowerCase()}`
        };
        this.context.trigger('header.link.click', field);
    }

    createClickHandler = (item) => {
        return (event) => {
            if (!item.link) {
                return false;
            }

            this.edapTrigger(item);

            // skip sub URL logic as link has already been manually updated
            if (item.linkUpdated) {
                return true;
            }

            // CAS Logout URLs need to be single enocded because of how their params are structured:
            // https://{DOMAIN}/haod/auth/signout.html?service={SINGLE_ENCODED_RETURN_URL}
            let singleEncodedURI = encodeURIComponent(window.location.pathname + window.location.search);

            // if traveler logged in, perform specific link update
            const newLink = item.link.replace(
                travelerRE,
                `service=$1${singleEncodedURI}`
            );

            // if we generate a new link, user has navigated to a sub URL in the same application
            // and we should redirect them there.  Otherwise let default user-agent behavior handle
            // rendered link
            if (newLink !== item.link) {
                event.stopPropagation();
                event.preventDefault();
                window.location.assign(newLink);
            }

            return true;
        };
    }

    clickHandlerOnUserButton = () => {
        this.edapTrigger({text: 'user'});
    }

    renderItem = (item, index) => {
        if (item.cssClass === 'divider') {
            return (
                <DropdownItem className="divider" key={index} />
            );
        }

        return (
            <DropdownItem
                dataBypass
                key={index}
                link={item.link}
                onClick={this.createClickHandler(item)}
                svgMarkup={travelerSvgMap[item.icon]}
                text={item.text}
            />
        );
    }

    render() {
        if (!this.props.items) {
            return null;
        }

        let id = 'site-header__traveler';

        const toggle = (
            <button
                aria-expanded="false"
                aria-haspopup="true"
                className="site-header-nav__toggle Dropdown__toggle"
                id={id}
            >
                <img
                    alt="avatar"
                    aria-hidden="true"
                    className="site-header-nav__avatar img-circle"
                    src={this.props.avatar.image}
                />
                <span className="site-header-nav__icon-label">{this.props.label}</span>
                <SVGIcon className="Dropdown__toggle-icon" inlineFlex markup={CHEVRON_DOWN__16}/>
            </button>
        );

        return (
            <Dropdown
                className="site-header-nav__dropdown"
                customToggle={toggle}
                dropdownRight
                id={id}
                label={this.props.label}
                onDropdownShow={this.clickHandlerOnUserButton}
            >
                {this.props.items.map(this.renderItem)}
            </Dropdown>
        );
    }
}
